import { useMutation } from "@tanstack/react-query";
import {
  createInsurersAPI,
  deleteInsurersAPI,
  updateInsurersAPI,
} from "./insurers.api";
import { handleNetworkError } from "@repo/ui/libs";

const useAddInsurersMutation = () => {
  return useMutation({
    mutationFn: createInsurersAPI,
    onError: handleNetworkError,
  });
};

const useUpdateInsurersMutation = () => {
  return useMutation({
    mutationFn: updateInsurersAPI,
    onError: handleNetworkError,
  });
};

const useDeleteInsurersMutation = () => {
  return useMutation({
    mutationFn: deleteInsurersAPI,
    onError: handleNetworkError,
  });
};

export {
  useAddInsurersMutation,
  useUpdateInsurersMutation,
  useDeleteInsurersMutation,
};
